import React, { useState } from "react";
import { heroContent, siteInfo } from "../../data/mockData";
import { ArrowRight, Play, X, MapPin } from "lucide-react";

const HeroSection = () => {
  const [videoOpen, setVideoOpen] = useState(false);

  return (
    <>
      {/* Hero */}
      <section className="relative h-screen min-h-[700px] flex items-center">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${heroContent.image})` }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#1B2A4A]/90 via-[#1B2A4A]/60 to-transparent" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 w-full">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-[#C9A96E] text-sm font-medium mb-8">
              <MapPin size={14} />
              Blenheim, Chatham-Kent
            </div>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif font-bold text-white leading-[1.1] mb-4">
              {heroContent.title}
              <span className="block text-[#C9A96E] mt-2">
                {heroContent.subtitle}
              </span>
            </h1>
            <p className="text-lg text-white/70 leading-relaxed mb-10 max-w-lg">
              {heroContent.description}
            </p>
            <div className="flex flex-wrap gap-4">
              <a
                href="/booking"
                className="inline-flex items-center gap-2 px-8 py-4 bg-[#C9A96E] text-[#1B2A4A] font-semibold rounded-md hover:bg-[#d4b97e] transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5"
              >
                {heroContent.ctaPrimary}
                <ArrowRight size={18} />
              </a>
              <button
                onClick={() => setVideoOpen(true)}
                className="inline-flex items-center gap-3 px-8 py-4 border-2 border-white/30 text-white font-semibold rounded-md hover:bg-white/10 hover:border-white/50 transition-all duration-300"
              >
                <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
                  <Play size={14} fill="white" />
                </div>
                Watch Promo
              </button>
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/50 animate-bounce">
          <span className="text-xs tracking-widest uppercase">Scroll</span>
          <div className="w-px h-8 bg-white/30" />
        </div>
      </section>

      {/* Video Modal */}
      {videoOpen && (
        <div
          className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-6"
          onClick={() => setVideoOpen(false)}
        >
          <button
            className="absolute top-6 right-6 text-white hover:text-[#C9A96E] transition-colors"
            onClick={() => setVideoOpen(false)}
          >
            <X size={32} />
          </button>
          <div
            className="w-full max-w-4xl aspect-video"
            onClick={(e) => e.stopPropagation()}
          >
            <iframe
              src={`${siteInfo.youtubePromo}?autoplay=1`}
              title="Willow Ridge Promo"
              className="w-full h-full rounded-lg"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </>
  );
};

export { HeroSection };
